import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {Guidebook} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {useSummary} from 'context/summary';
import {useFetchGuidebooks} from 'hooks/guidebooks/useFetchGuidebooks';
import {GuidebooksList} from 'components/GuidebooksList';

function GuidebooksNavigationList() {
  const {getFullPath} = usePath();
  const navigate = useNavigate();
  const {reservationId} = useSummary();
  const {data} = useFetchGuidebooks({reservationId});
  const guidebooks = data?.items;

  const handleNavigate = (guidebook: Guidebook) => {
    navigate(getFullPath(`${PATHS.guidebook}/${guidebook?.guidebook_group_id}`));
  };

  if (!guidebooks?.length) return null;

  return <GuidebooksList guidebooks={guidebooks} onItemClick={handleNavigate} />;
}

export {GuidebooksNavigationList};
